<template>
  <div class="button-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ButtonGroup',
}
</script>

<style lang="scss" scoped>
/* 按钮组 */
.button-group {
  display: flex;
  gap: 12px;
  margin-top: 16px;
  justify-content: center;

  .el-button {
    min-width: 120px;
  }
}
</style>
